import React from 'react';
import compact from 'lodash/compact';

import Divider from '../../Divider';
import StrapiLink from '../../StrapiLink/StrapiLink';
import { TwoColumnsAndLinksFragment } from '../../../../graphql.schema';

import * as styles from './index.module.scss';

export const StrapiTwoColumnsAndLinks = ({
  headingOne,
  headingTwo,
  descriptionOne,
  descriptionTwo,
  linksOne,
  linksTwo,
}: TwoColumnsAndLinksFragment) => {
  return (
    <div className={styles.root}>
      <div className="columns">
        <div className="column is-5 is-offset-1">
          <h3 className="title is-3 brand-a">{headingOne}</h3>
          <p className="black-2 is-text-2">{descriptionOne}</p>
        </div>
        <div className="column is-5 ">
          <h3 className="title is-3 brand-a">{headingTwo}</h3>
          <p className="black-2 is-text-2">{descriptionTwo}</p>
        </div>
      </div>
      <Divider paddingTop="20px" marginBottom="30px" />
      <div className="columns">
        <div className="column is-5 is-offset-1">
          {compact(linksOne).map((link) => (
            <React.Fragment key={link?.title}>
              <div className="is-flex mb-3 is-align-items-center">
                <StrapiLink {...link} />
              </div>
            </React.Fragment>
          ))}
        </div>
        <div className="column is-5 ">
          {compact(linksTwo).map((link) => (
            <React.Fragment key={link?.title}>
              <div className="is-flex mb-3 is-align-items-center">
                <StrapiLink {...link} />
              </div>
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};
